/**
 * SprintGoalBanner Component
 * AIDLC Administrative Backend
 *
 * Displays the sprint goal as a full-width banner above the Kanban columns.
 * Styled per Maya's spec: bg-blue-50 border-l-4 border-ldaja-blue.
 */

interface SprintGoalBannerProps {
  goal: string;
  sprintName: string;
  daysRemaining: number | null;
}

export function SprintGoalBanner({ goal, sprintName, daysRemaining }: SprintGoalBannerProps) {
  return (
    <div className="bg-blue-50 border-l-4 border-ldaja-blue p-3 rounded-r-lg mb-4">
      <div className="flex items-center justify-between">
        <div>
          <span className="text-[10px] font-semibold text-ldaja-blue uppercase tracking-wider">
            Sprint Goal
          </span>
          <p className="text-sm text-gray-800 mt-0.5">{goal || 'No goal set for this sprint.'}</p>
        </div>
        <div className="text-right flex-shrink-0 ml-4">
          <div className="text-xs font-medium text-gray-600">{sprintName}</div>
          {daysRemaining !== null && (
            <div className={`text-xs mt-0.5 ${daysRemaining <= 2 ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
              {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
